import { Chip } from "@mui/material";

const OrderNumberChip = ({ id, children }) => {
  return (
    <Chip
      style={{
        fontSize: "calc(10px * var(--unicity-font-scale, 1))",
        width: "fit-content",
        height: "20px",
        fontWeight: "600",
      }}
      data-test-id={id}
      label={children}
    />
  );
};

export { OrderNumberChip };
